<template>
  <div>
    <h3 class="heading semi-bold">Performance Scanning - Download Data</h3>

    <div class="row">
      <div class="col-md-12">
        <div class="grid bg-white">
          <div class="grid-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label"
                    >Filter by Employee</label
                  >
                  <div class="col-sm-12">
                    <v-select
                      multiple
                      :options="pageData.employees"
                      v-model="formData.employees"
                      label="title"
                      placeholder="Select Employee"
                      :reduce="(option) => option.employee_id"
                      :get-option-label="
                        (option) =>
                          option.employee_id + ' - ' + option.employee_name
                      "
                    >
                      <template v-slot:option="option">
                        [{{ option.employee_id }}] - {{ option.employee_name }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group row">
                  <label class="col-sm-12 col-form-label"
                    >Filter by Station</label
                  >
                  <div class="col-sm-12">
                    <v-select
                      multiple
                      :options="pageData.stations"
                      v-model="formData.stations"
                      label="title"
                      placeholder="Select Station"
                      :reduce="(option) => option.id"
                      :get-option-label="
                        (option) => option.department + ' - ' + option.name
                      "
                    >
                      <template v-slot:option="option">
                        [{{ option.department }}] - {{ option.name }}
                      </template>
                    </v-select>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-form-label col-md-6">
                        <label>Date From</label>
                        <datepicker
                          :clear-button="true"
                          placeholder="Date From"
                          v-model="formData.startDate"
                          input-class="form-control"
                        >
                        </datepicker>
                      </div>
                      <div class="col-form-label col-md-6">
                        <label>Date To</label>
                        <datepicker
                          :clear-button="true"
                          placeholder="Date To"
                          v-model="formData.endDate"
                          input-class="form-control"
                        >
                        </datepicker>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button class="btn-primary btn-large btn btn-block" @click="downloadData()">
      Download Data
    </button>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {
      errors: {},
      formData: {
        employees: [],
        stations: [],
        startDate: null,
        endDate: null,
      },
      pageData: {
        employees: [],
        stations: [],
      },
    };
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    async getPageData() {
      try {
        let results = await axios({
          method: "get",
          url: "/v2/performance_scanning/download",
        });
        const today = new Date();
        this.pageData = results.data.data;
        this.formData.startDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          1
        );
        this.formData.endDate = new Date();
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error("Unable to load page data, contact the admins");
        }
      }
    },

    async loadEmployee(supplierId) {
      let results = await axios({
        method: "get",
        url: "/v2/performance_scanning/employees/" + supplierId + "/edit",
      });
      this.employee = results.data.data.employee;
      this.pageData.departments = results.data.data.departments;
      this.pageData.positions = results.data.data.positions;
      this.pageData.marital_status = results.data.data.marital_status;
      this.pageData.positions_filtered = this.pageData.positions;

      if (this.employee.picture !== null) {
        this.loadProvidedImage(this.employee.picture);
      }
    },

    async downloadData() {
      let res = await axios
        .post("v2/performance_scanning/download", {
          responseType: "blob",
          ...this.formData,
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          let fileName =
            "PerformanceScanningRecords-" + moment().format("YYYY-MM-DD-H:m");
          link.setAttribute("download", `${fileName}.csv`);
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>

<style scoped>
@import "~sweetalert2/dist/sweetalert2.min.css";
@import "~vue-select/dist/vue-select.css";

.col-form-label {
  margin-top: 10px;
}

.vdp-datepicker input {
  min-height: 42px !important;
}
</style>
